export default "__VITE_ASSET__7056ba08__"